import { useState, useEffect } from 'react';

import { expValEquals } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';
import { cfetch } from '@confluence/network';
import { AccessStatus, useSessionData } from '@confluence/session-data';

const INVITE_CAPABILITIES_URL = '/gateway/api/v3/invitations/capabilities';

const hasDirectInviteCapabilities = async (cloudId: string) => {
	try {
		const response = await cfetch(
			`${INVITE_CAPABILITIES_URL}?resource=ari:cloud:platform::site/${cloudId}`,
			{
				method: 'GET',
				headers: {
					ACCEPT: 'application/json',
				},
			},
		);

		if (!response.ok) {
			return false;
		}

		const data = await response.json();
		return data.some(
			(item) => item?.resourceARI?.includes('confluence') && item?.directInvite?.mode === 'ANYONE',
		);
	} catch (e) {
		return false;
	}
};

export const useIsEligibleXProductUserInvite = () => {
	const { accessStatus, cloudId } = useSessionData();
	const isLicensed =
		accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus === AccessStatus.LICENSED_USE_ACCESS;
	const [canUserInviteDirect, setCanUserInviteDirect] = useState(false);

	useEffect(() => {
		const getCapabilities = async () => {
			if (!fg('cc_virality_x_product_user_invite_kill_switch') || !isLicensed) {
				setCanUserInviteDirect(false);
				return;
			}

			const capabilities = await hasDirectInviteCapabilities(cloudId);
			setCanUserInviteDirect(capabilities);
		};

		void getCapabilities();
	}, [cloudId, isLicensed]);

	return canUserInviteDirect && expValEquals('cc_virality_x_product_user_invite', 'cohort', 'test');
};
